import BaseService from './BaseService'

class PaymentGatewayService extends BaseService {
  constructor () {
    super('/payments')
  }

  // Backend returns business-level gateway roles and settings
  async getCapabilities () {
    // Prefer business-info endpoint for roles/config
    return this.customRequest('get', '/../business-info/payments/online-gateway')
  }

  selectGateway (capabilities, { context } = { context: 'cnp' }) {
    const roles = capabilities?.gateway_roles || {}

    const resolveRoleGateway = (role, fallback) => {
      const value = roles?.[role]
      if (!value) return fallback
      if (typeof value === 'string') return value
      if (typeof value === 'object' && typeof value.gateway === 'string') {
        return value.gateway
      }
      return fallback
    }

    if (context === 'card_present') {
      return resolveRoleGateway('card_present', 'dejavoo')
    }

    return resolveRoleGateway('cnp', capabilities?.online_gateway || 'dejavoo')
  }
}

export default new PaymentGatewayService()


